import React from "react"
import Helmet from "react-helmet"
import { generatePageUrl, getImageUrl } from "../../common/utils"
import {BUOY_SITE_URL} from "../../common/constants"

const Head = ({ data, metaTitle, metaDescription, relUrl, prevImg }) => {
  let title = metaTitle ? metaTitle : data.site.siteMetadata.title
  let description = metaDescription
    ? metaDescription
    : data.site.siteMetadata.description
  let url = generatePageUrl(relUrl)
  let image = prevImg ? `${getImageUrl(prevImg)}?auto=format,compress` : `${getImageUrl("buoy-open-graph.jpg")}?auto=format,compress`
  let buoyLogo = "https://buoyhealth.imgix.net/buoy_logo.png"
  let corporateSchema = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Buoy Health",
    url: "https://www.buoyhealth.com/",
    description: data.site.siteMetadata.description,
    logo: buoyLogo,
    foundingDate: "2014-01-01",
    address: {
      "@type": "PostalAddress",
      streetAddress: "883 Bolyston St",
      addressLocality: "Boston",
      addressRegion: "MA",
      postalCode: "02116",
      addressCountry: "United States of America",
    },
    email: "support@buoyhealth.com",
    location: {
      "@type": "Place",
      name: "Buoy Health",
      hasMap:
        "https://www.google.com/maps/place/883+Boylston+St,+Boston,+MA+02116/@42.3484405,-71.0834484,17z/data=!4m13!1m7!3m6!1s0x89e37a0fb8d76b61:0xe2267be57923e115!2s883+Boylston+St,+Boston,+MA+02116!3b1!8m2!3d42.3486744!4d-71.0836219!3m4!1s0x89e37a0fb8d76b61:0xe2267be57923e115!8m2!3d42.3486744!4d-71.0836219",
      url: "https://www.buoyhealth.com/",
      geo: {
        "@type": "GeoCoordinates",
        latitude: "42.3484405",
        longitude: "-71.083448",
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "883 Bolyston St",
        addressLocality: "Boston",
        addressRegion: "MA",
        postalCode: "02116",
        addressCountry: "United States of America",
      },
    },
  }
  let siteSchema = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    about: {
      "@type": "Corporation",
      name: "Buoy Health",
      image: buoyLogo,
    },
    description: description,
    copyrightYear: `${new Date().getFullYear()}`,
    keywords:
      "Buoy, Buoy Health, AI Health Assistant, Artificial Intelligence in Healthcare, Symptom checker",
    url: url,
    image: image,
    copyrightHolder: {
      "@type": "Corporation",
      name: "Buoy Health",
      url: "https://www.buoyhealth.com/",
      description: data.site.siteMetadata.description,
      logo: buoyLogo,
      foundingDate: "2014-01-01",
      address: {
        "@type": "PostalAddress",
        streetAddress: "883 Bolyston St",
        addressLocality: "Boston",
        addressRegion: "MA",
        postalCode: "02116",
        addressCountry: "United States of America",
      },
    },
  }
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta httpEquiv="Accept-CH" content="Width" />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="600" />
      <meta property="og:image:height" content="400" />
      <meta
        property="og:author"
        content="https://www.facebook.com/buoyhealth/"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@buoyhealth" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="amp-google-client-id-api" content="googleanalytics" />
      <meta name="p:domain_verify" content="e141d1408efbe2843a0ffecafcfba1bf"/>
      <meta name="msvalidate.01" content="8DDAE1D23A2E9FECD7C589F097468D66" />
      <meta name="google-site-verification" content="_2Q2G77at1kpKFhSCk1gvNFmMZGzvN_hqXOjVtj_vEA" />
      
      <link rel="canonical" href={url} />
      <link
        rel="shortcut icon"
        type="image/png"
        href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}favicon.ico?v=2`}
      />

      <link
        href="https://fonts.googleapis.com/css?family=Roboto:400,500,700"
        rel="stylesheet"
      />

      <link rel="manifest" href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}manifest.json`} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <link rel="apple-touch-icon" href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_icons/icon-192x192.png`} />

      // iPhone XS Max (1242px x 2688px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1242x2688.png`} rel="apple-touch-startup-image"
        media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)" />
      // iPhone X, XS (1125px x 2436px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1125x2436.png`} rel="apple-touch-startup-image"
        media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)" />
      // iPhone XR (828px x 1792px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_828x1792.png`} rel="apple-touch-startup-image"
        media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)" />
      // iPhone 6, 7, 8 (750px x 1334px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_750x1334.png`} rel="apple-touch-startup-image"
        media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)" />
      // iPhone 7+, 8+ (1242px x 2208px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1242x2208.png`} rel="apple-touch-startup-image"
        media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3)" />
      // iPhone 6+ (1242px x 2208px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1242x2208.png`} rel="apple-touch-startup-image"
        media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 3)" />
      // iPhone 5, SE (640px x 1136px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_640x1136.png`} rel="apple-touch-startup-image"
        media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)" />
      // iPad Mini, Air, Pro 9.7" (1536px x 2048px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1536x2048.png`} rel="apple-touch-startup-image"
        media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)" />
      // iPad Pro 10.5" (1668px x 2224px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1668x2224.png`} rel="apple-touch-startup-image"
        media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)" />
      // iPad Pro 11" (1668px x 2388px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_1668x2388.png`} rel="apple-touch-startup-image"
        media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)" />
      // iPad Pro 12.9" (2048px x 2732px)
      <link href={`${BUOY_SITE_URL}/${data.site.siteMetadata.mainImagePath}app_splash/splash_2048x2732.png`} rel="apple-touch-startup-image"
        media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)" />

      <script type="application/ld+json">
        {JSON.stringify(corporateSchema)}
      </script>

      <script type="application/ld+json">{JSON.stringify(siteSchema)}</script>
    </Helmet>
  )
}

export { Head as default }



// WEBPACK FOOTER //
// ./src/components/Head/index.js